module.exports = __webpack_public_path__ + "static/oldportfolio-9d421933322d1f3313b010b907469161.png";